module.exports = __webpack_public_path__ + "img/guandai_xc5.36213206.jpg";